import React from 'react';

export default function Home() {

  return (
    <div className="content">

      <div>
        <h2>Malachi 3:10</h2>
        <p> Bring ye all the tithes into the storehouse, that there may be meat in mine house, and prove me now herewith, saith the Lord of hosts, if I will not open you the windows of heaven, and pour you out a blessing, that there shall not be room enough to receive it.</p>
      </div>

    </div>

    )
}